export default "__VITE_ASSET__CNc$WXmH__"